import React, { Component } from 'react';

class PhotoGallerySearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            foto:props.foto
        };
    }
    async componentDidMount() {
        //AT THE RENDERING SEARCH
        //console.log("foto",this.state.foto)

    }

    render() {
        const { foto } = this.state;

        return (
            <section className="room-section room-list-style pt-0 pb-0">
                    <div className="room-list-loop-search">
                        <div className="room-box mb-00">
                            <div style={{marginRight: "0px",marginLeft: "0px"}} className="row no-gutters justify-content-center">
                                <div className="col-lg-12 col-md-12">
                                    <div className="room-img-wrap-details-gallery">
                                        <div  className="room-img-deteils" style={{ backgroundImage: "url(" +this.state.foto+ ")",borderRadius: "0.5rem" }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                </div>
            </section>

        );
    }
}

export default PhotoGallerySearch;